import React, { useEffect, useState, useCallback, useRef, memo } from "react";
import {
  Input,
  Button,
  Spinner,
} from "reactstrap";

import widgetEmbed from "../../../assets/images/icons-component/embed.png";

import { screenState } from "../../../store/screen/slice";
import { useAppSelector } from "../../../store/hooks";

const Index = (props: any) => {
  const { username } = useAppSelector(state => screenState(state));
  const { config, CodeValue, SetPending, onUpdateSize, onUpdate, actionEnd, setCanCopy } = props;
  const [insetCheck, setInsetCheck] = useState(config.data?.codeStr ?? "");
  const [embedCode, setEmbedCode] = useState(config.data?.codeStr ?? "");
  const [embedSource, setEmbedSource] = useState<any>(config.data?.codeStr ?? "");
  const [embedStatus, setEmbedStatus] = useState<any>("0");

  useEffect(() => {
    if (config.data && config.data?.codeStr) {
      setInsetCheck(config.data?.codeStr);
      setEmbedCode(config.data?.codeStr);
      setSource(config.data?.codeStr);
      setEmbedStatus("1");
      SetPending(false);
    }
  }, [config.data?.codeStr]);
  
  const checkValue = () => {
    if (insetCheck === "") return;
    setSource(insetCheck);
    SetPending(true);
    setEmbedStatus("2");
  };

  const setSource = (code: any) => {
    if (code.indexOf("iframe") >= 0) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(code, 'text/html');
      const iframe = doc.querySelector('iframe');
  
      if (iframe) {
        const attributes = iframe.attributes;
        const attributesObj: any = {};
  
        for (let i = 0; i < attributes.length; i++) {
          const attr = attributes[i];
          attributesObj[attr.name] = attr.value;
        }
        setEmbedSource(attributesObj);
      } else {
        setEmbedSource("");
        setEmbedStatus("0");
      }
      setTimeout(() => {
        setEmbedStatus("1");
      }, 1000);
    } else {
      if (code.indexOf("google") >= 0 && code.indexOf("view") >= 0) {
        const googlePreview = code.replace("/view", "/preview");
        setEmbedSource({
          src: googlePreview
        });
      } else {
        setEmbedSource({
          src: code
        });
      }
      setTimeout(() => {
        setEmbedStatus("1");
      }, 200);
    }
  };

  const handleLoad = () => {
    let update: any;
    if (embedSource?.height && embedSource?.width) {
      onUpdateSize({ height: Number(embedSource?.height), width: Number(embedSource?.width) });
      const data = config.data;
      data.codeStr = insetCheck;
      CodeValue(insetCheck);
      SetPending(false);
      update = { id: config.id, height: Number(embedSource?.height), width: Number(embedSource?.width), listTitle: embedSource.src, data: data };
    } else {
      const data = config.data;
      data.codeStr = insetCheck;
      CodeValue(insetCheck);
      SetPending(false);
      const listTitle = embedSource.src;
      update = { id: config.id, data: data  };
      if (listTitle !== "") {
        update["listTitle"] = listTitle;
      }
    }
    if ((!username && !config?.studentName) || username === config.studentName) {
      onUpdate(update);
      actionEnd(true);
    }
  };

  return (
    <React.Fragment>
      <div style={{ height: '100%', width: '100%', position: 'absolute' }}>
        {embedStatus === "1" && embedSource? (
          <div style={{ height: '100%', width: '100%' }}>
            <iframe
              src={embedSource.src}
              title="video player"
              style={{ height: '100%', width: '100%', border: "none", overflow: "hidden" }}
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
              allowFullScreen
              onLoad={handleLoad}
              onFocus={() => {
                setCanCopy(false);
              }}
              onBlur={() => {
                setCanCopy(true);
              }}
            >
            </iframe>
          </div>
        ) : (
          <div className="relative flex h-full flex-col items-center justify-center gap-6 p-6 bg-screen " style={{ cursor: 'auto' }}>
            <div className="widget-head text-area-head">
              <img src={widgetEmbed} alt="" />
            </div>
            <textarea 
              style={{ resize: "none" }}
              className="ts-text-area h-100 !text-lg"
              onChange={(e) => {setInsetCheck(e.target.value)}}
              placeholder="輸入嵌入代碼或 iframe..."
              defaultValue={embedCode}
              data-interaction-target-type="false"
              onFocus={() => {
                setCanCopy(false);
              }}
              onBlur={() => {
                setCanCopy(true);
              }}
            >
            </textarea>
            <Button
              color="primary"
              className={`ts-playBtn btn-load rounded-pill text-sm px-4 h-11 font-semibold ${ insetCheck === ""? "ts-disabled" : null }`}
              onClick={checkValue}
              data-interaction-target-type="false"
            >
              <div className="relative justify-center h-100 w-100">
                {embedStatus === "0"? (
                  <span>建立</span>
                ) : embedStatus === "2"? (
                  (
                    <span className="ts-load d-flex justify-center items-center">
                      <Spinner size="sm" className="flex-shrink-0"> Loading... </Spinner>
                    </span>
                  )
                ) : null}
              </div>
            </Button>
          </div>
        )}
      </div>
      {username !== config.studentName && embedStatus !== "1"? (
        <div className="absolute h-100 w-100 top-0 start-0" style={{ zIndex: 2 }}></div>
      ) : null}
    </React.Fragment>
  );
};

export default memo(Index);